// รายการรถ ตัวกรอง และการโหลดข้อมูลเป็นของ v2 เองทั้งหมด — ไม่พึ่ง component / redux / saga ของหน้าเดิม

import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { Col, Row } from 'antd'
import Fullscreen from 'react-full-screen'

import { GeneralStyledContent } from '../../../../styled/common-styled'
import AuthorizeComponent from '../../../auth/components/AuthorizeComponent'

import getText from '../dict'
import useOrgFilters from '../lib/useOrgFilters'
import { ALL_STATUS, useFilterVehicles, useWallVehicles } from '../lib/useVehicleLists'
import useWallSlots from '../lib/useWallSlots'
import FilterModal from './FilterModal'
import Toolbar from './Toolbar'
import VehicleList from './VehicleList'
import VideoWall from './VideoWall'
import '../assets/css/index.css'

const WALL_OFFSET = 190 // ความสูงของ header + toolbar + ระยะขอบ
const LIST_REFRESH_MS = 60 * 1000 // รีเฟรชรายการรถทุก 1 นาที เท่าหน้าเดิม

// body เดียวกับหน้าเดิม · plateno_select = รถที่อยู่บนจอ
function listQuery(applied, wallIds) {
  return {
    list_vehicle_id: applied.vehicleIds,
    orderBy: 'plate_no',
    orderType: 'asc',
    selectedDivision: applied.org.division,
    selectedDepartment: applied.org.department,
    selectedSection: applied.org.section,
    selectedPlant: applied.org.plant,
    vehicleStatus: applied.vehicleStatus,
    plateno_select: wallIds,
  }
}

function IndexV2(props) {
  const { auth, language } = props
  const txt = getText(language)

  const [isFull, setIsFull] = useState(false)
  const [filterOpen, setFilterOpen] = useState(false)
  const [scrollToId, setScrollToId] = useState(null)

  const org = useOrgFilters(auth)
  const wall = useWallSlots(1)
  const list = useWallVehicles(auth)
  const filterVehicles = useFilterVehicles(auth, org.selected)

  // ค่าร่างในหน้าต่างตัวกรอง = สถานะรถตรงนี้ + หน่วยงานใน org.selected
  const [vehicleStatus, setVehicleStatus] = useState(ALL_STATUS)
  // ค่าที่รายการรถใช้จริง — เปลี่ยนเฉพาะตอนกดตกลง รอบรีเฟรชจึงไม่หยิบค่าร่างไปใช้
  const [applied, setApplied] = useState(() => ({
    org: org.selected,
    vehicleStatus: ALL_STATUS,
    vehicleIds: [],
  }))
  const latest = useRef(null)
  latest.current = { applied, wallIds: wall.ids, load: list.load } // load ตัวล่าสุด = token / profile ล่าสุด

  const vehiclesById = useMemo(() => {
    const map = {}
    list.vehicles.forEach(v => {
      map[v.id] = v
    })
    return map
  }, [list.vehicles])

  const slots = wall.buildSlots(vehiclesById)

  const wallHeight = isFull
    ? window.innerHeight
    : Math.max(320, window.innerHeight - WALL_OFFSET)

  const onVehicleClick = useCallback(
    vehicleId => {
      wall.toggle(vehicleId)
      wall.focus(vehicleId)
    },
    [wall],
  )

  // โหลดครั้งแรก แล้วรีเฟรชทุก 1 นาทีด้วยค่าที่ใช้อยู่
  useEffect(() => {
    const first = latest.current
    list
      .load(listQuery(first.applied, first.wallIds))
      .then(found => {
        // ลิงก์ ?vehicle_id= จากหน้าอื่น: เปิดคันนั้นบนจอแล้วเลื่อนรายการไปหา
        const id = parseInt(new URLSearchParams(window.location.search).get('vehicle_id'), 10)
        const vehicle = id ? found.find(v => v.id === id) : null
        if (vehicle) {
          onVehicleClick(vehicle.id)
          setScrollToId(vehicle.id)
        }
      })
      .catch(() => {})

    const timer = setInterval(() => {
      const now = latest.current
      now.load(listQuery(now.applied, now.wallIds)).catch(() => {})
    }, LIST_REFRESH_MS)
    return () => clearInterval(timer)
  }, []) // ครั้งเดียวตอนเปิดหน้า — ค่าล่าสุดอ่านจาก latest

  const okFilter = vehicleIds => {
    const next = { org: org.selected, vehicleStatus, vehicleIds }
    setApplied(next)
    setFilterOpen(false)
    list.load(listQuery(next, wall.ids)).catch(() => {})
  }

  // ยกเลิก = คืนค่าร่างเป็นค่าที่ใช้อยู่ · รายการรถไม่เคยใช้ค่าร่าง จึงไม่ต้องโหลดใหม่
  const cancelFilter = () => {
    if (applied.org !== org.selected) org.restore(applied.org)
    setVehicleStatus(applied.vehicleStatus)
    setFilterOpen(false)
  }

  return (
    <AuthorizeComponent {...props} matching_name="honeytoastlivestream">
      <GeneralStyledContent>
        <Row style={{ margin: '0 0 6px 0' }}>
          <Col span={24}>
            <div className="semi-bold-16" style={{ color: 'black' }}>
              {txt.title}
            </div>
          </Col>
        </Row>

        <Row gutter={8}>
          <Col
            span={6}
            style={{
              maxHeight: `${wallHeight + 28}px`,
              overflowY: 'auto',
            }}
          >
            <VehicleList
              vehicles={list.vehicles}
              loading={list.loading}
              selectedIds={wall.ids}
              scrollToId={scrollToId}
              txt={txt}
              onSelect={onVehicleClick}
            />
          </Col>

          <Col span={18}>
            <Toolbar
              layout={wall.layout}
              txt={txt}
              onLayoutChange={wall.changeLayout}
              onFullscreen={() => setIsFull(true)}
              onStopAll={wall.clear}
              onFilter={() => setFilterOpen(true)}
            />

            <Fullscreen enabled={isFull} onChange={setIsFull}>
              <VideoWall
                slots={slots}
                layout={wall.layout}
                height={wallHeight}
                selectedId={wall.selectedId}
                txt={txt}
                onSelect={wall.focus}
                onRemove={wall.remove}
              />
            </Fullscreen>
          </Col>
        </Row>

        <FilterModal
          visible={filterOpen}
          txt={txt}
          vehicleStatus={vehicleStatus}
          onVehicleStatusChange={setVehicleStatus}
          org={org}
          vehicleOptions={filterVehicles}
          appliedVehicleIds={applied.vehicleIds}
          onOk={okFilter}
          onCancel={cancelFilter}
        />
      </GeneralStyledContent>
    </AuthorizeComponent>
  )
}

const mapStateToProps = ({ auth, ui: { language } }) => ({ auth, language })

export default connect(mapStateToProps)(IndexV2)
